import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { TollFreeLayout } from 'pages/settings/pages/compliance/pages/tollFree/layout/TollFreeLayoutContent'
import { TollFreePage } from 'pages/settings/pages/compliance/pages/tollFree/ui/tollFreePage'

export const TollFreeMainPageRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<TollFreeLayout />}>
        <Route path={'/'} element={<TollFreePage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
